// extracted by mini-css-extract-plugin
export default {"errorMessage":"InputForm_errorMessage__FFinH"};